<template>
  <b-badge :style="badgeConfig.badgeStyle" class="lab-status-badge">
    {{ badgeConfig.badgeLabel }}
  </b-badge>
</template>

<script>
export default {
  name: "TransferStatusBadge",
  props: {
    status: {
      type: String,
      default: null,
    },
  },
  computed: {
    badgeConfig() {
      if (this.status === "PENDING") {
        return {
          badgeStyle: {
            backgroundColor: "#F6E8B2",
            color: "#CFA505",
          },
          badgeLabel: "รอดำเนินการ",
        };
      }
      if (this.status === "CONFIRMED") {
        return {
          badgeStyle: {
            backgroundColor: "#D8EFDD",
            color: "#155724",
          },
          badgeLabel: "โอนสำเร็จ",
        };
      }
      if (this.status === "CANCELED") {
        return {
          badgeStyle: {
            backgroundColor: "#F8EBEA",
            color: "#BB342F",
          },
          badgeLabel: "ปฏิเสธการโอน",
        };
      }
      return {
        badgeStyle: {
          backgroundColor: "#000",
          color: "#fff",
        },
        badgeLabel: "ตรวจสอบสถานะการโอน",
      };
    },
  },
};
</script>

<style scoped>
.lab-status-badge {
  font-size: 0.85em;
  padding: 0.35em 0.65em;
}
</style>
